// breakpoints must be synced with /apps/naturkartan_web/assets/stylesheets/common/base/_mq.scss
let breakpoints = {
  xxxsmall: 0,
  xxsmall: 375,
  xsmall: 480,
  small: 640,
  medium: 768,
  large: 960,
  xlarge: 1024,
  xxlarge: 1200,
  xxxlarge: 1400,
  xxxxlarge: 1680,
}
breakpoints = {
  ...breakpoints,
  mobile: breakpoints.medium,
  "mobile-header": breakpoints.large,
}

function emify(px) {
  return `${px / 16}em`
}

const mq = {}
Object.entries(breakpoints).forEach(([key, val]) => {
  mq[`${key}-down`] = `(max-width: ${emify(val)})`
  mq[`${key}-up`] = `(min-width: ${emify(val + 1)})`
  mq[`${key}-up-eq`] = `(min-width: ${emify(val)})`
})

export function matchMqBreakpoint(breakpoint) {
  return window.matchMedia(mq[breakpoint]).matches
}

export function shouldMqReducedMotion() {
  return window.matchMedia(`(prefers-reduced-motion: reduce)`).matches
}
